var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"buttonFooter",class:{ ios: _vm.isIOS, ipx: _vm.isIPX, ipmx: _vm.isIPMX }},[_c('van-button',{staticClass:"buttonFooter--button",attrs:{"type":"info","block":"","disabled":_vm.disabled,"loading":_vm.loading},on:{"click":_vm.onTap}},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }